export enum Semester {
  Spring = 'spring',
  Autumn = 'autumn',
}
